var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 0L32 4V32H7L0 28V0H25Z",
  fill: "#94D4E3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.4572 11.3107L13.9572 21.8107C13.5667 22.2012 12.9335 22.2012 12.543 21.8107L7.54297 16.8107L8.95718 15.3965L13.2501 19.6894L23.043 9.89648L24.4572 11.3107Z",
  fill: "#1B1B1B"
})));
export { SvgCheckmark as ReactComponent };
export default __webpack_public_path__ + "assets/c4e0ecaf.svg";